import React, { memo } from 'react';
import { useManage } from '../services/managed-permissions';

export default memo(function PermissionsLoader(props) {
  const { error, loaded } = useManage({
    minimumTime: 3000
  });

  if (loaded) {
    return props.children(props);
  }

  return (
    <div className={`permissions-loading ${error ? 'permissions-loading-message' : 'coin-flip'}`}>
      {
        error ? 'Error occurred, please contact system support' : (
          <React.Fragment>
            <div className="coin-tails">
              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/US_One_Cent_Rev.png/240px-US_One_Cent_Rev.png" />
            </div>
            <div className="coin-heads">
              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2e/US_One_Cent_Obv.png/240px-US_One_Cent_Obv.png" />
            </div>
          </React.Fragment>
        )
      }
    </div>
  )
});



// WEBPACK FOOTER //
// ./src/app/permissions-loader.js